export const UNIFORM_LOGIN_COPY = {
  title: "Verifique seu email",
  description:
    "Se este email puder acessar a plataforma, enviaremos um link de login. Verifique a caixa de entrada e a pasta de spam.",
} as const;

/**
 * O corpo de check-user-exists não decide o login.
 * `{ ok: true }` sem `exists` segue. `exists: false` também segue.
 * Só `ok: false` pede nova tentativa.
 */
export function loginProceeds(body?: { ok?: boolean; exists?: boolean } | null): boolean {
  if (body && body.ok === false) return false;
  return true;
}

export function loginFeedback() {
  return {
    title: UNIFORM_LOGIN_COPY.title,
    description: UNIFORM_LOGIN_COPY.description,
    showLinkSent: true,
  };
}
